export default __webpack_public_path__ + "static/media/DSC_0556.fc2ae8fd.webp";